import React from 'react';
import { motion } from 'framer-motion';
export function TopBar() {
  return <motion.div className="bg-[#C0392B] text-center py-3 px-4 font-bold tracking-wider text-[#F1C40F] text-[10px]" animate={{
    opacity: [1, 0.8, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity
  }} data-id="element-162">
      🔥 OFERTA LIMITADA — ACCESO INMEDIATO POR DESCARGA DIGITAL 🔥
    </motion.div>;
}